import GetYourPumpThroughInsuranceTheme from './GetYourPumpThroughInsuranceTheme'

export class GetPumpThroughInsuranceModalTheme extends GetYourPumpThroughInsuranceTheme {
  readonly buttonRadius = 24
}
